/**
 * Filter Checkbox
 * Styled checkbox displayed exclusivly in filter modal
 */
import React from 'react';

import useUniqueId from '@hooks/useUniqueId';

import { CheckboxStyle, LabelStyle } from './FilterCheckbox.style';

const FilterCheckbox: React.FC<{
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
}> = ({ onChange, checked = false }) => {
  const id = useUniqueId('filter-checkbox');

  return (
    <>
      <CheckboxStyle
        checked={checked}
        data-testid="filter-checkbox"
        id={id}
        onChange={onChange}
        type="checkbox"
      />
      <LabelStyle htmlFor={id} />
    </>
  );
};

export default FilterCheckbox;
